export default __webpack_public_path__ + "static/Canela-LightItalic-e7a927b2bd2c26f7d90f071c8decfe8f.woff2";